export default "__VITE_ASSET__Cp5hpfqX__"